import cx from 'classnames'
import styles from './experiment-favourite-cta.module.css'
import { HeartIcon } from '../favourite-cta/icon/heart-icon'

export interface ExperimentFavouriteCTAProps {
  isPending: boolean
  isSaved: boolean
  onClick: () => void
}

const ExperimentFavouriteCTA = ({
  isPending,
  isSaved,
  onClick,
}: ExperimentFavouriteCTAProps) => {
  const FAVOURITE_CAR = 'Add car to favourites'
  const UNFAVOURITE_CAR = 'Remove car from favourites'
  const favouriteIconName = isSaved ? 'Filled' : 'Outline'

  return (
    <button
      type="button"
      aria-label={isSaved ? UNFAVOURITE_CAR : FAVOURITE_CAR}
      onClick={onClick}
      className={cx(styles['favouriteCta'], {
        [styles['favouriteCtaPending']]: isPending,
        [styles['favouriteCtaSaved']]: isSaved,
      })}
    >
      {<HeartIcon name={favouriteIconName} size={24} />}
    </button>
  )
}

export default ExperimentFavouriteCTA
